import api from '.';
import store from '../redux/store';
import { AxiosError } from 'axios';
import { handleApiError } from '../utils/creditHandleAPIError';
import {
  CreditApplicationDetails,
  CreditApplicationStatusResponse,
  CreditApplicationStatusType,
  CreditFetchType,
} from '../types/credit';

// API to get either status or full credit details
export const getCreditApplicationDetails = async (
  fetchType: CreditFetchType = 'details',
): Promise<CreditApplicationStatusResponse | CreditApplicationDetails | null> => {
  try {
    const config =
      fetchType === 'status'
        ? {
            headers: {
              'x-fields': '{ id status credit_limit }',
            },
          }
        : undefined;
    const isReapplyMode = localStorage.getItem('credit_reapply_mode') === 'true';
    let url = `/companies/${store.getState().auth.authContext
      ?.companyId}/credit-applications?type=current`;

    if (isReapplyMode && fetchType === 'details') {
      url += '&re_apply=true';
    }
    const { data } = await api.get(url, config);
    return data;
  } catch (error: unknown) {
    // Check if it's an Axios error with a 404 status
    if (error instanceof Error) {
      const axiosError = error as AxiosError;
      if (
        axiosError.response?.status === 404 &&
        // Safely access the message property
        typeof axiosError.response?.data === 'object' &&
        axiosError.response?.data !== null &&
        'message' in axiosError.response.data &&
        typeof (axiosError.response.data as Record<string, unknown>).message === 'string' &&
        ((axiosError.response.data as Record<string, unknown>).message as string).includes(
          'No credit application found for the company',
        )
      ) {
        if (fetchType === 'status') {
          return {
            id: null,
            status: CreditApplicationStatusType.NOT_STARTED,
            credit_limit: null,
          } as CreditApplicationStatusResponse;
        }
        return null;
      }
    }

    return handleApiError(error, `getCreditApplicationDetails (${fetchType})`);
  }
};

export const updateCreditApplicationDetails = async (
  request: Partial<CreditApplicationDetails>,
): Promise<CreditApplicationDetails> => {
  try {
    const isReapplyMode = localStorage.getItem('credit_reapply_mode') === 'true';
    let url = `/companies/${store.getState().auth.authContext?.companyId}/credit-applications`;
    if (isReapplyMode) {
      url += '?re_apply=true';
    }
    const { data } = await api.put<CreditApplicationDetails>(url, request);
    return data;
  } catch (error: unknown) {
    return handleApiError(error, 'updateCreditApplicationDetails');
  }
};
